module.exports = __webpack_public_path__ + "static/img/block7.5245068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block7.png
// module id = Dnld
// module chunks = 1